import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import "./admin.css";

axios.defaults.withCredentials = true;

const AdminTicket = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showSidebar, setShowSidebar] = useState(true);
  const [role, setRole] = useState("");

  const [lockedUntil, setLockedUntil] = useState(
    parseInt(localStorage.getItem("lockedUntil") || "0"),
  );
  const [timeLeft, setTimeLeft] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const savedErr = localStorage.getItem("loginError");
    if (savedErr) setError(savedErr);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = Date.now();
      if (lockedUntil > now) {
        setTimeLeft(Math.ceil((lockedUntil - now) / 1000));
      } else {
        if (timeLeft !== 0) {
          setError("");
          localStorage.removeItem("loginError");
        }
        setTimeLeft(0);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [lockedUntil, timeLeft]);

  useEffect(() => {
    (async () => {
      try {
        const me = await axios.get("/authadmin/me");

        setIsLoggedIn(true);
        setRole(me.data.user?.role || "");
        setEmail(me.data.user?.email || "");

        if (window.location.pathname === "/admin") {
          navigate("/admin/tickets", { replace: true });
        }
      } catch {
        setIsLoggedIn(false);
      }
    })();
  }, [navigate]);

  const handleLogin = async () => {
    setError("");

    const now = Date.now();
    if (lockedUntil > now) {
      setError(
        `Locked, try again in ${Math.ceil((lockedUntil - now) / 1000)} seconds`,
      );
      return;
    }

    try {
      await axios.post("/authadmin", { email, password });

      localStorage.removeItem("loginError");
      localStorage.removeItem("lockedUntil");
      setLockedUntil(0);

      const me = await axios.get("/authadmin/me");
      setIsLoggedIn(true);
      setRole(me.data.user?.role || "");
      setEmail(me.data.user?.email || "");

      navigate("/admin/tickets");
    } catch (e) {
      const errorMsg = e?.response?.data?.error || "Login failed";
      setError(errorMsg);
      localStorage.setItem("loginError", errorMsg);

      if (errorMsg.includes("Locked")) {
        const match = errorMsg.match(/(\d+)\s*seconds/);
        const seconds = match ? parseInt(match[1]) : 300;

        const lockTime = Date.now() + seconds * 1000;
        localStorage.setItem("lockedUntil", lockTime.toString());
        setLockedUntil(lockTime);

        setTimeLeft(seconds);
      }
    }
  };

  const handleLogout = async () => {
    if (!window.confirm("ยืนยันออกจากระบบ?")) return;

    try {
      await axios.post("/authadmin/logout");
    } finally {
      setIsLoggedIn(false);
      setEmail("");
      setPassword("");
      setRole("");
      navigate("/admin");
    }
  };

  const menuItems = [
    { path: "dashboard", label: "Dashboard", icon: "📊" },
    {
      path: "customer-activity-logs",
      label: "Customer Activity Logs",
      icon: "📄",
    },
    { path: "users", label: "Users", icon: "👥" },
    { path: "tickets", label: "Tickets", icon: "🎫" },
    ...(role === "admin"
      ? [{ path: "agent", label: "Add agent", icon: "🧑‍💼" }]
      : []),
    { path: "department", label: "Department", icon: "🏢" },
    { path: "new", label: "Create Tickets", icon: "🆕" },
    { path: "ticket-assessments", label: "Ticket Assessments", icon: "⭐" },
    { path: "agent-logs", label: "Agent Activity Logs", icon: "🕒" },
  ];

  if (!isLoggedIn) {
    return (
      <div className="login-container-new">
        <h2>Admin Login</h2>

        {error && <p className="error-message-new">{error}</p>}

        <input
          className="input-field-new"
          type="email"
          placeholder="Email"
          value={email}
          disabled={timeLeft > 0}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          className="input-field-new"
          type="password"
          placeholder="Password"
          value={password}
          disabled={timeLeft > 0}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          className="login-button-new"
          onClick={handleLogin}
          disabled={timeLeft > 0}
          style={{ opacity: timeLeft > 0 ? 0.5 : 1 }}
        >
          {timeLeft > 0 ? `Locked (${timeLeft}s)` : "Login"}
        </button>
      </div>
    );
  }

  return (
    <div className="admin-ticket-container">
      <header className="admin-header">
        <div className="logo">
          <h1>ProScope Support Ticket System</h1>
        </div>
        <div className="user-info">
          <span>Welcome, {email}</span>
          <button onClick={handleLogout} className="bt-css">
            Log Out
          </button>
        </div>
      </header>

      <div className="admin-content">
        {showSidebar && (
          <nav className="admin-sidebar">
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="menu-icon">{item.icon}</span> {item.label}
              </NavLink>
            ))}
          </nav>
        )}

        {!showSidebar && (
          <button
            onClick={() => setShowSidebar(true)}
            className="bt-css"
            style={{
              position: "absolute",
              left: 0,
              top: 80,
              zIndex: 1000,
              margin: "10px",
            }}
          >
            Show Menu
          </button>
        )}

        <main className="main-content">
          <div className="content-body">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminTicket;
